import { Component, input } from '@angular/core';
import { RouterLink } from '@angular/router';
import { Device } from '@rocksoft/shared';

@Component({
  selector: 'era-device-swapped-current-action-bar-ui',
  templateUrl: './device-swapped-current-action-bar.component.html',
  imports: [RouterLink],
})
export class DeviceSwappedCurrentActionBarComponent {
  public readonly allowSpare = input(false);
  public readonly allowUnavailable = input(false);

  public readonly device = input.required<Device>();
}
